import React from 'react'
import { User } from '../../../../assests/ExportImageIcon'
import '../../../hotel/hotel-details/hotelDetail.css'
import './busSeatSelection.css'
import './busRating.css'

// Static placeholder — no bus reviews API exists yet, so the data below is the
// same static mock hotel/cruise detail pages use (see hotelDetail.jsx /
// cruiseDetail.jsx), reusing their exact .reviewPart__grid/.reviewSummary/
// .reviewCard CSS so this looks identical. Content only (no tab bar) —
// rendered by SeatBookingPanel.jsx alongside the RATINGS & REVIEWS tab.
const REVIEW_SUMMARY = {
    average: 4.8,
    totalReviews: 1234,
    breakdown: [
        { star: 5, count: 856, percent: 88, color: 'green' },
        { star: 4, count: 247, percent: 55, color: 'green' },
        { star: 3, count: 86, percent: 45, color: 'yellow' },
        { star: 2, count: 31, percent: 45, color: 'red' },
        { star: 1, count: 14, percent: 45, color: 'red' },
    ],
    categories: [
        { label: 'Cleanliness', value: 4.9 },
        { label: 'Service', value: 4.8 },
        { label: 'Location', value: 4.7 },
        { label: 'Value for Money', value: 4.6 },
    ],
}

const REVIEWS = [
    {
        name: 'Rajesh Kumar',
        rating: 5,
        time: '2 days ago',
        text: 'Excellent property with outstanding service! The staff went above and beyond to make our stay comfortable.',
    },
    {
        name: 'Priya Sharma',
        rating: 4,
        time: '5 days ago',
        text: 'Excellent property with outstanding service! The staff went above and beyond to make our stay good.',
    },
]

const GoldStar = ({ filled = true }) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 10.65 2.89 12.95 3.8 8.33.34 5.13l4.68-.55L7 .29l1.98 4.29 4.68.55-3.46 3.2.92 4.62Z" fill={filled ? '#F5A623' : '#E5E7EB'} />
    </svg>
)

const BusRating = () => {
    return (
        <div className='seatSelectPanel'>
            <div className='seatSelectPanel__title'>Ratings &amp; Reviews</div>

            <div className='busRatingPanel__body'>
                <div className='reviewPart__grid'>
                    <div className='reviewSummary bgWhite commonBorder borderRadius20'>
                        <div className='reviewSummary__scoreRow'>
                            <div className='reviewSummary__score'>{REVIEW_SUMMARY.average}</div>
                            <div>
                                <div className='reviewSummary__stars'>
                                    {Array.from({ length: 5 }).map((_, index) => (
                                        <GoldStar key={index} filled={index < Math.round(REVIEW_SUMMARY.average)} />
                                    ))}
                                </div>
                                <div className='reviewSummary__count'>{REVIEW_SUMMARY.totalReviews.toLocaleString('en-IN')} reviews</div>
                            </div>
                        </div>

                        <div className='reviewSummary__bars'>
                            {REVIEW_SUMMARY.breakdown.map((row) => (
                                <div className='reviewBarRow' key={row.star}>
                                    <span className={`reviewBarRow__label reviewBarRow__label--${row.color}`}>{row.star}★</span>
                                    <span className='reviewBarRow__track'>
                                        <span className={`reviewBarRow__fill reviewBarRow__fill--${row.color}`} style={{ width: `${row.percent}%` }} />
                                    </span>
                                    <span className='reviewBarRow__count'>{row.count}</span>
                                </div>
                            ))}
                        </div>

                        <div className='reviewSummary__divider' />

                        <div className='reviewSummary__categories'>
                            {REVIEW_SUMMARY.categories.map((category) => (
                                <div className='reviewCategory' key={category.label}>
                                    <span className='reviewCategory__label'>{category.label}</span>
                                    <span className='reviewCategory__value'>{category.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='reviewList'>
                        {REVIEWS.map((review, index) => (
                            <div className='reviewCard bgWhite commonBorder borderRadius20' key={index}>
                                <div className='reviewCard__head'>
                                    <span className='reviewCard__avatar'>
                                        <img src={User} alt="" />
                                    </span>
                                    <div>
                                        <div className='reviewCard__name'>{review.name}</div>
                                        <div className='reviewCard__meta'>
                                            <span className='reviewCard__stars'>
                                                {Array.from({ length: 5 }).map((_, starIndex) => (
                                                    <GoldStar key={starIndex} filled={starIndex < review.rating} />
                                                ))}
                                            </span>
                                            <span className='reviewCard__time'>{review.time}</span>
                                        </div>
                                    </div>
                                </div>
                                <p className='reviewCard__text'>{review.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusRating
